import { useEffect, useRef, useState } from "react";
import { DataGrid, Column } from "devextreme-react/data-grid";
import { ModalBulkSiteCreationSubDetailProps } from "./BulkSiteCreation.types";
import { Modal } from "../../cui/components/Modal/Modal";
import { constants } from './BulkSiteCreation.types'

import { createSitesClientApi } from "../../api-client-nswag/taxportal-client-runtime";

const { SITES_SELECTED_TITLE } = constants;
type DatagridRefType = DataGrid;
const initialStateData = { pending: true, changes: [] };

export const ModalBulkSiteCreationSubDetail = ({
  id,
  isDisplayModal,
  handleClose
}: ModalBulkSiteCreationSubDetailProps) => {
    const detailsGridRef = useRef<DatagridRefType>(null);
    const styles = { position: "right", margin: "0", height: "100%", maxHeight: "100%" };
    const [changeSubDetailData, setChangeSubDetailData] = useState<any>(initialStateData);

    const fetchData = async () => {
        try {
          if (!id) {
            setChangeSubDetailData({ pending: false, changes: [] });
            return;
          }
          setChangeSubDetailData(initialStateData);
          const result = await createSitesClientApi.taxportal_GetSubProcessExecutionDetails(String(id));
          setChangeSubDetailData({ pending: false, changes: result.data });
        } catch (error) {
      };
    }

    useEffect(() => {
        fetchData();
      }, [id]);

    return(
        <Modal
            title={SITES_SELECTED_TITLE}
            btnCloseText="Close"
            handleClose={handleClose}
            btnCloseTop={true}
            maxWidth="sm"
            isDisplayModal={isDisplayModal}
            styles={styles}
        >
        <div>
            <DataGrid
                id="grid-modal-changes"
                ref={detailsGridRef}
                keyExpr="id"
                allowColumnResizing
                dataSource={changeSubDetailData.changes}
                noDataText={changeSubDetailData.pending ? "Loading..." : "No data"}
                showBorders
                wordWrapEnabled
                >
                <Column dataField="description" caption="Description" />
                <Column dataField="status" caption="Status" />
                <Column dataField="statusMessage" caption="Status Message"/>
            </DataGrid>
        </div>
    </Modal>
    );
}